<template>
  <div class="quicklinks-section">
    <h3 class="quicklinks-title">{{ title }}</h3>
    <p class="quicklinks-list">
      <span v-for="(link, index) in links" :key="link.url" class="quicklinks-item">
        <span v-if="index > 0" class="quicklinks-sep">|</span>
        <a :href="link.url" target="_blank" rel="noopener noreferrer">{{ link.label }}</a>
      </span>
    </p>
  </div>
</template>

<script>
// 其他快捷链接 - 公共组件，样式隔离（scoped）
// 可通过 props 自定义标题与链接列表，默认提供站点常用快捷链接
export default {
  name: 'QuickLinks',
  props: {
    title: {
      type: String,
      default: '其他快捷链接'
    },
    links: {
      type: Array,
      default: () => ([
        { label: '3QTools 官方网站', url: 'https://3qtools.cn' },
        { label: 'APP下载示例站', url: 'https://home.3qtools.cn' },
        // { label: '自研共享浏览器扩展', url: 'https://extentions.3qtools.cn' },
      ])
    }
  }
};
</script>

<style scoped>
.quicklinks-section {
  padding: 10px 30px 15px;
  background-color: #fff;
  display: flex;
  gap: 20px;
  align-items: center;
  border-radius: 12px;
  margin-top: 20px;
}

.quicklinks-title {
  margin-bottom: 0;
  color: #3498db;
  font-size: 18px;
}

.quicklinks-list {
  line-height: 1.6;
  color: #bdc3c7;
  font-size: 14px;
  margin: 0;
}

.quicklinks-sep {
  margin: 0 8px;
  color: #bdc3c7;
}

.quicklinks-section a {
  color: #3498db;
  text-decoration: none;
}

.quicklinks-section a:hover {
  text-decoration: underline;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .quicklinks-section {
    padding: 10px 20px 20px;
    display: block;
  }

  .quicklinks-title {
    margin-bottom: 10px;
  }
}
</style>
